/**
 * 템플릿 글꼴 — core 의 woff2(`packages/core/fonts`)를 콘솔 번들에 싣고 `@font-face` 를 만든다.
 *
 * 플레이어(`apps/player-web/src/template-fonts.ts`)와 **같은 파일**이다 — 미리보기가 화면과 같은
 * 글꼴로 그려야 한다. CDN 을 쓰지 않는 까닭도 같다: 사내망에 설치한 서버의 콘솔은 인터넷이 없다.
 * 글꼴은 그 글꼴을 쓰는 미리보기·고르기 견본이 뜰 때만 읽힌다.
 */
import { fontUrlLookup, templateFontFaceCss } from '@signageone/core';

const FILES = import.meta.glob('../../../../packages/core/fonts/*.woff2', {
  query: '?url',
  import: 'default',
  eager: true,
}) as Record<string, string>;

/** 글꼴 파일 이름 → 번들 주소 — [화면 편집] 이 템플릿 사본에 글꼴을 품을 때 받는다. */
export const templateFontUrl = fontUrlLookup(FILES);

export const TEMPLATE_FONT_FACES = templateFontFaceCss(templateFontUrl);

/**
 * 콘솔 문서 자체에도 한 번 싣는다 — 글꼴 고르기의 견본 글자가 그 글꼴로 보이게.
 * 미리보기 iframe 은 따로 싣는다(문서마다 `@font-face` 가 따로다).
 */
export function installTemplateFontFaces(doc: Document = document): void {
  if (doc.getElementById('so-template-fonts')) return;
  const style = doc.createElement('style');
  style.id = 'so-template-fonts';
  style.textContent = TEMPLATE_FONT_FACES;
  doc.head.append(style);
}
